const Header = ({ children }: { children: React.ReactNode }) => {
  return <h1 className="text-white text-bold text-3xl">{children}</h1>;
};

export default Header;
